import * as React from "react"
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import Layout from "../components/Layout"
import Seo from "../components/Seo"

const JessellaneousPage = () => {
	return (
		<Layout>
			<Seo title="Jessellaneous" />
			<h2>Jessellaneous</h2>
			<div className="main--centerwrapper">
				<StaticImage
					src="../images/photos/pressRes/Jesse-high-5.jpg"
					alt="Jesse Rivest in Brasilia, by Murilo Fabrino, 2021"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					height={333}
				/>
			</div>

			<h3>Miscellaneous music from Jesse Rivest</h3>

			<p>
				<span className="italic"><span className="bold">Jessellaneous</span></span> is a new artist moniker for special or miscellaneous releases and collaborations
				that I am involved in.<br />
				(In decreasing chronological order:)
			</p>

			<h4>'Oumuamua: a collab</h4>

			<p>
				<span className="italic"><span className="bold">Jessellaneous</span></span> appears again in January 2026 on a collab
				with friend Murilo Fabrino. The result is Dos CaBras' original song, <span className="italic">'Oumuamua</span>.
				Read about it at the <Link to="/collab/">collabs page</Link>.
			</p>

			<div className="main--centerwrapper p">
				<StaticImage
					src="../images/collab artwork/JRCOLLAB07 dos cabras - 'oumuamua.jpg"
					alt="Dos CaBras - 'Oumuamua - cover art"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					width={500}
				/>
			</div>

			<h4>One: the first one</h4>

			<p>
				On October 30, 2025, the <Link to="/music/18/">first music from <span className="italic">Jessellaneous</span></Link> was released to streaming platforms.
				The first news post regarding <span className="italic">Jessellaneous</span> was posted on <Link to="/news/202510/">October 30, 2025</Link>.
				Undecided whether I'll continue to list them here; one can go to my <Link to="/music/">music</Link> page and use the filters there to see them listed;
				one can also go to the <Link to="/collab/">collabs page</Link>  and look for more there.
				Thanks for listening!
			</p>

			<div className="main--centerwrapper p">
				<StaticImage
					src="../images/catalog artwork/JRIVEST18 one front.jpg"
					alt="Jessellaneous - one - cover art"
					placeholder="blurred"
					layout="constrained"
					className="main--centered"
					imgClassName="img--bordered-small"
					width={500}
				/>
			</div>



		</Layout>
	);
}

export default JessellaneousPage;
